module.exports = __webpack_public_path__ + "media/images/planning_a_trip_to_japan/id/5/1-cca690d8ced9c30ea33e30916592cb67.jpg";